<script>
  export default {
    name: 'overlay-menu'
  }
</script>

<template lang="pug">
  .overlay_menu
    button.btn.btn-primary.btn-icon.btn-icon-mini.btn-round
      i.zmdi.zmdi-close
    .container
      .row.clearfix
        .card
          .body
            .input-group.m-b-0
              input.form-control(type='text', placeholder='Search...')
              span.input-group-addon
                i.zmdi.zmdi-search
        .card.links
          .body
            .row
              .col-lg-3.col-md-6.col-sm-12
                h6 App
                ul.list-unstyled
                  li
                    a(href='mail-inbox.html') Inbox
                  li
                    a(href='chat.html') Chat
                  li
                    a(href='events.html') Calendar
                  li
                    a(href='file-dashboard.html') File Manager
                  li
                    a(href='contact.html') Contact list
              .col-lg-3.col-md-6.col-sm-12
                h6 User Interface (UI)
                ul.list-unstyled
                  li
                    a(href='ui_kit.html') UI KIT
                  li
                    a(href='tabs.html') Tabs
                  li
                    a(href='range-sliders.html') Range Sliders
                  li
                    a(href='modals.html') Modals
                  li
                    a(href='alerts.html') Alerts
                  li
                    a(href='dialogs.html') Dialogs
                  li
                    a(href='collapse.html') Collapse
              .col-lg-3.col-md-6.col-sm-12
                h6 Sample Pages
                ul.list-unstyled
                  li
                    a(href='image-gallery.html') Image Gallery
                  li
                    a(href='profile.html') Profile
                  li
                    a(href='timeline.html') Timeline
                  li
                    a(href='pricing.html') Pricing
                  li
                    a(href='invoices.html') Invoices
                  li
                    a(href='faqs.html') FAQs
                  li
                    a(href='search-results.html') Search Results
              .col-lg-3.col-md-6.col-sm-12
                h6 About
                ul.list-unstyled
                  li
                    a(href='http://thememakker.com/about/', target='_blank') About
                  li
                    a(href='http://thememakker.com/contact/', target='_blank') Contact Us
                  li
                    a(href='http://thememakker.com/admin-templates/', target='_blank') Admin Templates
                  li
                    a(href='http://thememakker.com/services/', target='_blank') Services
                  li
                    a(href='http://thememakker.com/portfolio/', target='_blank') Portfolio
      .row.clearfix
        .col-lg-12.col-md-12
          .social
            a.icon(href='https://www.facebook.com/thememakkerteam', target='_blank')
              i.zmdi.zmdi-facebook
            a.icon(href='https://www.behance.net/thememakker', target='_blank')
              i.zmdi.zmdi-behance
            a.icon(href='javascript:void(0);')
              i.zmdi.zmdi-twitter
            a.icon(href='javascript:void(0);')
              i.zmdi.zmdi-linkedin
            p
              | Coded by WrapTheme
              br
              |  Designed by
              a(href='http://thememakker.com/', target='_blank') thememakker.com

</template>



// WEBPACK FOOTER //
// src/layout/overlay-menu.vue